import NotificationsApi from '../api/notifications';

export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  getters: {
    notifications(state) {
      return state.notifications;
    },
    lastNewNotification(state) {
      return state.notifications[0] ? Date.parse(state.notifications[0].created_at) : Date.now();
    },
  },
  actions: {
    getNotifications(context) {
      return new Promise((resolve, reject) => {
        NotificationsApi.getNotifications()
          .then((response) => {
            const sorted = response.sort(x => -new Date(x.created_at).getTime());
            context.commit('SET_NOTIFICATIONS', sorted);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearNotifications(context) {
      return new Promise((resolve, reject) => {
        NotificationsApi.clearNotifications()
          .then((response) => {
            context.commit('CLEAR_NOTIFICATIONS');
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkNotifications(context) {
      return new Promise((resolve, reject) => {
        NotificationsApi.checkNotifications()
          .then((response) => {
            const notifs = context.getters.notifications.map((n) => {
              return {
                ...n,
                seen: true,
              };
            });
            context.commit('SET_NOTIFICATIONS', notifs);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    pushNotification(context, payload) {
      return new Promise((resolve, reject) => {
        NotificationsApi.pushNotification(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_NOTIFICATIONS: (state, notifications) => {
      state.notifications = notifications;
    },
    CLEAR_NOTIFICATIONS: (state) => {
      state.notifications = [];
    },
  },
};
